import { AiOutlineFullscreenExit } from 'react-icons/ai';
import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { useFullscreen } from '~/contexts/FullscreenContext';

export function FullScreenDeactivate() {
  const { t } = useTranslate();

  const fullscreen = useFullscreen();

  return (
    <Button
      size="icon"
      variant="white"
      className="fixed top-6 right-6 z-1100 [&_svg]:text-gray-750 [&_svg]:w-auto! [&_svg]:h-auto!"
      title={t('actions.deactivate', { t: t('common.fullscreen') })}
      onClick={fullscreen.deactivate}
    >
      <AiOutlineFullscreenExit size={24} />
    </Button>
  );
}
